/** 权限相关 */
import {roleAdminCode} from '@/utils/constant'

export default{
    namespaced: true,
    state:()=>({
        token:'',
        roles: [],// 角色
        sidebarRoute: [],// 菜单路由
    }),
    mutations:{
        // 设定token
        SET_TOKEN(state, token){
            state.token=token
        },
        // 设置菜单遍历所需数据
        SET_SIDEBAR_ROUTE(state, routes){
            state.sidebarRoute = routes
        },
        // 设定角色
        SET_ROLES(state, roles){
            state.roles=roles
        },
        // 登出处理
        LOGIN_OUT(state){
            state.token='',
            state.roles=[]
            state.sidebarRoute=[]
        },
    },
    getters:{
        // 判单角色是否是管理员
        isAdmin(state){
            return state.roles.some(v=>v.code===roleAdminCode)
        },
    }
}